// A page's main action on a phone: a round button above the tab bar, where the
// thumb rests. From `md` the page's header button does the job.
import { cn } from "@crew/ui/lib/utils";
import type { ComponentProps } from "react";

export function Fab({
  label,
  className,
  ...props
}: Omit<ComponentProps<"button">, "aria-label"> & { label: string }) {
  return (
    <button
      type="button"
      aria-label={label}
      data-slot="fab"
      className={cn(
        "fixed right-[max(1rem,env(safe-area-inset-right))] bottom-[calc(5rem+env(safe-area-inset-bottom))] z-20 flex size-14 cursor-pointer items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg outline-none focus-visible:ring-3 focus-visible:ring-ring/50 active:translate-y-px md:hidden [&_svg]:size-6",
        className,
      )}
      {...props}
    />
  );
}
